import type { IPascoRepository } from "@src/domain/pascos/repository/pasco_repository";
import type { PascoDTO } from "../dto";
import { PascoDtoMapper } from "../mappers/pasco-dto.mapper";

/**
 * Use Case: Review PASCO
 * Marks a PASCO record as reviewed
 */
export class ReviewPascoUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) { }

    /**
     * Execute the use case
     * @param pascoId - The unique identifier of the PASCO to review
     * @returns Promise<PascoDTO> - The reviewed PASCO DTO
     * @throws Error if pascoId is invalid
     */
    async execute(pascoId: string): Promise<PascoDTO> {
        if (!pascoId || pascoId.trim() === '') {
            throw new Error('PASCO ID is required');
        }

        const pasco = await this.pascoRepository.review(pascoId);
        return PascoDtoMapper.toDTO(pasco);
    }
}